import { type AggregationFn } from "@tanstack/react-table";

import { isComparableNumber, round } from "./aggregationFnUtils";

export const range: AggregationFn<unknown> = (columnId, leafRows, _immediateChildRows) => {
	let min: number | undefined;
	let max: number | undefined;

	// NOTE: If we ever support nested columns, we might want to `range` the `immediateChildRows` of
	// this grouping, since they'll have aggregated their own children.
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (isComparableNumber(value)) {
			if (min === undefined || min > value) {
				min = value;
			}
			if (max === undefined || max < value) {
				max = value;
			}
		}
	});

	if (min !== undefined && max !== undefined) {
		return round(max - min);
	}
};
